import Footer from "../components/Footer";
import Header from "../components/Header";
import style from "../style/notfound.module.css"

function NotFound() {
  return (
    <div>
      <Header />
      <div className={style.found}>

      <h1>Coming Soon</h1>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
